import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { Link } from 'react-router'
import cx from 'classnames'

import hiResLogo from '../../resources/img/logo-hires.png'
import TrackList from '../../components/tracklist/TrackList'
import redirectToApp from '../../utils/redirectToApp'
import { displayCdQuality, displayReleasedDate } from '../../utils/display'

import { getTrack as getTrackAction } from './trackActions'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as selectors from './trackSelectors'
import Loader from '../../components/loader/Loader'
import appConst from '../../constant/appConst'
import { Helmet } from 'react-helmet'
import ShareComponent from '../../components/share/ShareComponent'
import ReadMoreComponent from "../../components/ReadMoreComponent"
import GTMController from "../../utils/kpi/GTMController"

const fields = [{
	type: 'number',
	render: () => 1
},{
	type: 'name',
	render: track => `${track.title}${track.version ? ` (${track.version})` : ''}`
},{
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

class TrackPage extends PureComponent {

	componentWillMount() {
		const { getTrack, id } = this.props
		getTrack(id)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		const { id } = this.props
		if (id !== nextProps.id) {
			this.props.clearPlayqueue()
		}
		if (nextProps.id) {
			GTMController.pushTrackPageEvent()
		}
	}

	render() {
		const {
			id,
			title,
			version,
			album,
			artist,
			composer,
			performer,
			performers,
			duree,
			isHiRes,
			orderUrl,
			release_date_stream,
			maximum_bit_depth,
			maximum_channel_count,
			maximum_sampling_rate
		} = this.props
		const { intl } = this.context

		let dureeAffichee
		if (duree > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duree/3600)}`, minutes: `${Math.floor((duree % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duree/60)}`, seconds: `${duree % 60}` }
			)
		}

		let artistData = null
		if (performer) {
			artistData = performer
		} else if (artist) {
			artistData = artist
		}
		const isPreOrder = release_date_stream > (Date.now() / 1000)
		const performProd = []
		const performMix = []
		if (performers) {
			const tiretSplit = performers.split(' - ')
			let performerIndex
			tiretSplit.forEach(tiretRow => {
				// On récupère l'index de la première virgule :
				// avant -> le nom du perfomer
				// après -> ses fonctions
				const commaIndex = tiretRow.indexOf(',')
				const performerName = tiretRow.substr(0, commaIndex)
				const performerRoles = tiretRow.substr(commaIndex)

				// Séparation selon la fonction
				let groupUsed
				if (!!appConst.mixFilter.find(item => tiretRow.indexOf(item) !== -1)) {
					groupUsed = performMix
				} else {
					groupUsed = performProd
				}

				// Check si le nom est déjà présent avec une autre fonction
				performerIndex = groupUsed.findIndex(perf => perf.name && perf.name.indexOf(performerName) !== -1)
				if (performerIndex !== -1) {
					groupUsed[performerIndex].roles += `${performerRoles}`
				} else {
					groupUsed.push({ name: performerName, roles: performerRoles })
				}
			})
		}
		return (
			<Loader>
				<div className="page page--track">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.track" }, { trackName: title, artistName: artist.name })}</title>
						<link rel="canonical" href={`https://open.qobuz.com/track/${id}`} />
					</Helmet>
					<div className="page__background page__background--album" style={{ backgroundImage: `url(${album.pochette})` }} />

					<div className="page__container clearfix">

						{/* HEADING BLOC */}
						<div className="heading">
							<img className="heading__cover" src={album.pochette} alt={album.title} />
							<div className={cx('heading__container', 'heading__container--album', { 'heading__container--no-hires': !isHiRes })}>
								<div className="heading__texts">
									<h1 className="heading__title">{`${title}${version ? ` (${version})` : ''}`}</h1>
									{artistData &&
										<p className="heading__infos heading__infos--link">
											<Link to={`/artist/${artistData.id}`}>{artistData.name}</Link>
										</p>
									}
									<p className="heading__infos heading__infos--link heading__infos--album">
										<Link to={`/album/${album.id}`}>{album.title}</Link>
									</p>
								</div>
								<div className="heading__buttons">
									<a
										className="heading__button heading__button--album pct pct-play"
										onClick={() => redirectToApp('track', id)}
									>
										{intl.formatMessage({ id: 'buttons.listen' })}
									</a>
									{orderUrl &&
										<a
											className="heading__button heading__button--album pct pct-buy"
											href={`${appConst.albumOderUrl}${album.id}`}
											onClick={() => GTMController.pushEvent(GTMController.EVENTS.TRACK_BUY)}
											target="_blank"
										>
											{intl.formatMessage({ id: 'buttons.buy' })}
										</a>
									}
									<ShareComponent GTMCopyEvent={GTMController.EVENTS.TRACK_SHARE}/>
								</div>
								<div className="quality quality--track">
									<p className="quality__text">{intl.formatMessage({ id: 'infos.available' })}</p>
									<div className="quality__container">
										{isHiRes ?
											<img
												className="quality__image"
												src={hiResLogo}
												alt={intl.formatMessage({ id: 'infos.hires' })}
												height={35}
												width={35}
											/> : <span className="quality__image pct pct-disc" />
										}
										<p className="quality__text">
											{displayCdQuality(maximum_bit_depth, maximum_sampling_rate, maximum_channel_count)}
										</p>
									</div>
								</div>
							</div>
						</div>

						{/* INFOS BLOC */}
						<div className="infos">
							<h2 className="infos__title">{intl.formatMessage({ id: 'aside.title' })}</h2>
							{album.genre && album.genre.id && <p className="infos__subtitle">{intl.formatMessage({ id: `genre.genre-id-${album.genre.id}`})}</p>}
							<p className="infos__track">{displayReleasedDate(album.release_date_original, intl)} - {dureeAffichee}</p>
							{!isPreOrder &&[
								<div className="infos__credits" key="infos__credits">
									<ul className="infos__credit infos__credit--first">
										{album.label &&
										<li className="infos__item">
											{intl.formatMessage({ id: 'infos.label' }, { label: album.label.name})}
										</li>
										}
										{composer &&
										<li className="infos__item">
											{intl.formatMessage({ id: 'infos.composer' }, { composer: composer.name})}
										</li>
										}
									</ul>
									{performProd && performProd.length > 0 &&
									<div className="infos__credit">
										<p className="infos__subtitle infos__subtitle--credits">{intl.formatMessage({id: 'infos.producers'})}</p>
										<ul className="infos__items">
											{
												performProd.map(producer => (
													<li className="infos__item" key={`producer-${producer.name}`}>
														<span className="infos__text">{producer.name}</span>{producer.roles}
													</li>))
											}
										</ul>
									</div>
									}
									{performMix && performMix.length > 0 &&
									<div className="infos__credit">
										<p className="infos__subtitle infos__subtitle--credits">{intl.formatMessage({id: 'infos.mixers'})}</p>
										<ul className="infos__items">
											{
												performMix.map(mixer => (
													<li className="infos__item" key={`producer-${mixer.name}`}>
														<span className="infos__text">{mixer.name}</span>{mixer.roles}
													</li>))
											}
										</ul>
									</div>
									}
								</div>,
								<ReadMoreComponent key="readMoreComponent" id={id} type={"track"} />
							]}
						</div>

						{/* TRACKLIST BLOC */}
						<div className="tracklist">
							<h2 className="tracklist__title">{intl.formatMessage({ id: 'tracklist.title.track' })}</h2>
							<TrackList
								fields={fields}
								displayWork={false}
								GTMPlayEvent={GTMController.EVENTS.TRACK_PLAY}
								listContainerClassName="tracklist__container tracklist__container--track"
								listClassName="tracklist__tracks"
							/>
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

TrackPage.propTypes = {
	id: PropTypes.string,
	getTrack: PropTypes.func,
	clearPlayqueue: PropTypes.func,
	title: PropTypes.string,
	album: PropTypes.shape({
		id: PropTypes.string,
		title: PropTypes.string,
		pochette: PropTypes.string,
		genre: PropTypes.object,
		release_date_original: PropTypes.string
	}),
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	release_date_stream: PropTypes.number,
	duree: PropTypes.number,
	isHiRes: PropTypes.bool,
	orderUrl: PropTypes.string,
	performers: PropTypes.string,
	composer: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	performer: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	maximum_bit_depth: PropTypes.number,
	maximum_channel_count: PropTypes.number,
	maximum_sampling_rate: PropTypes.number,
}

TrackPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	title: selectors.getTitle(state),
	version: selectors.getVersion(state),
	album: selectors.getAlbum(state),
	artist: selectors.getArtist(state),
	release_date_stream: selectors.getStreamableAt(state),
	duree: selectors.getDuree(state),
	isHiRes: selectors.isHiRes(state),
	orderUrl: selectors.getOrderUrl(state),
	composer: selectors.getComposer(state),
	performer: selectors.getPerformer(state),
	performers: selectors.getPerformers(state),
	maximum_bit_depth: selectors.getMaximumBitDepth(state),
	maximum_channel_count: selectors.getMaximumChannelCount(state),
	maximum_sampling_rate: selectors.getMaximumSamplingRate(state)
})

const actions = {
	getTrack: getTrackAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(TrackPage)



// WEBPACK FOOTER //
// ./src/pages/track/TrackPage.jsx